module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.listloading) ? _c('div', [_c('el-col', {
    staticClass: "toolbar uptool",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("DID：")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "clearable": "",
      "size": "small"
    },
    model: {
      value: (_vm.DIDinput),
      callback: function($$v) {
        _vm.DIDinput = $$v
      },
      expression: "DIDinput"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("发货日期：")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "size": "small",
      "value-format": "timestamp",
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.selectTime),
      callback: function($$v) {
        _vm.selectTime = $$v
      },
      expression: "selectTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("经销商：")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "min-width": "300px"
    },
    attrs: {
      "collapse-tags": "",
      "placeholder": "请选择",
      "multiple": "",
      "size": "small"
    },
    on: {
      "change": _vm.changeJxs
    },
    model: {
      value: (_vm.selectJxs),
      callback: function($$v) {
        _vm.selectJxs = $$v
      },
      expression: "selectJxs"
    }
  }, _vm._l((_vm.Dealerlist), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("重置刷新")])], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('span', {
    staticStyle: {
      "line-height": "41px",
      "font-size": "16px",
      "color": "blue",
      "margin-left": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("*蓝色字体为当前账号可修改部分，双击当前行弹出修改页面。")])])], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true,
      "id": "addMessage"
    }
  }, [_c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("显示内容:")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox-group', {
    on: {
      "change": _vm.showChange
    },
    model: {
      value: (_vm.checkList),
      callback: function($$v) {
        _vm.checkList = $$v
      },
      expression: "checkList"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "a"
    }
  }, [_vm._v("财务模块")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "b"
    }
  }, [_vm._v("销售模块")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "c"
    }
  }, [_vm._v("生产模块")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "d"
    }
  }, [_vm._v("产品模块")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listloading),
      expression: "listloading"
    }],
    staticStyle: {
      "width": "99.9%"
    },
    attrs: {
      "id": "dataTable",
      "data": _vm.List,
      "border": "",
      "element-loading-text": "拼命加载中",
      "element-loading-background": "rgba(0, 0, 0, 0.8)",
      "element-loading-spinner": "el-icon-loading",
      "max-height": _vm.maxHeight
    },
    on: {
      "filter-change": _vm.Filterfind,
      "row-dblclick": _vm.ChangeIt
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "fixed": "",
      "prop": "sequenceNumber",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "DID",
      "fixed": "",
      "prop": "did",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "MAC",
      "prop": "mac",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "颜色",
      "prop": "color_code",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.colorCode(scope.row.color_code)) + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "版本",
      "prop": "color_code",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.EditionCode(scope.row.edition_code)) + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货单号",
      "prop": "deliveryOrder.serial_number",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货日期",
      "prop": "deliveryOrder.delivery_date",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.timeFormate(scope.row.deliveryOrder.delivery_date)) + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货人",
      "prop": "deliveryOrder.shipper",
      "min-width": "110"
    }
  }), _vm._v(" "), (_vm.cw) ? _c('el-table-column', {
    attrs: {
      "label": "财务模块",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "开票日期",
      "prop": "invoice.invoice_created_date",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limB) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.timeFormate(scope.row.invoice.invoice_created_date)))]) : _c('span', [_vm._v(_vm._s(_vm.timeFormate(scope.row.invoice.invoice_created_date)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开票状态",
      "prop": "invoice.invoice_status",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limB) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.invoiceState(scope.row.invoice.invoice_status)))]) : _c('span', [_vm._v(_vm._s(_vm.invoiceState(scope.row.invoice.invoice_status)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发票编号",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limB) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.invoice.invoice_serial_number))]) : _c('span', [_vm._v(_vm._s(scope.row.invoice.invoice_serial_number))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收款日期1st",
      "prop": "invoice.receipt_date",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limB) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.timeFormate(scope.row.invoice.receipt_date)))]) : _c('span', [_vm._v(_vm._s(_vm.timeFormate(scope.row.invoice.receipt_date)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收款金额1st",
      "prop": "invoice.receipt_amount",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limB) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.invoice.receipt_amount))]) : _c('span', [_vm._v(_vm._s(scope.row.invoice.receipt_amount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收款日期2nd",
      "prop": "invoice.receipt_date",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limB) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.timeFormate(scope.row.invoice.receipt_date_2nd)))]) : _c('span', [_vm._v(_vm._s(_vm.timeFormate(scope.row.invoice.receipt_date_2nd)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收款金额2nd",
      "prop": "invoice.receipt_amount",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limB) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.invoice.receipt_amount_2nd))]) : _c('span', [_vm._v(_vm._s(scope.row.invoice.receipt_amount_2nd))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收款日期3rd&after",
      "prop": "invoice.receipt_date",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limB) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.timeFormate(scope.row.invoice.receipt_date_finally)))]) : _c('span', [_vm._v(_vm._s(_vm.timeFormate(scope.row.invoice.receipt_date_finally)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收款金额3rd&after",
      "prop": "invoice.receipt_amount",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limB) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.invoice.receipt_amount_finally))]) : _c('span', [_vm._v(_vm._s(scope.row.invoice.receipt_amount_finally))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收款状态",
      "prop": "invoice.receipt_status",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limB) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.paymentState(scope.row.invoice.receipt_status)))]) : _c('span', [_vm._v(_vm._s(_vm.paymentState(scope.row.invoice.receipt_status)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "押金转销售",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limB) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.cashtosell(scope.row.invoice.is_deposit_to_sale)))]) : _c('span', [_vm._v(_vm._s(_vm.cashtosell(scope.row.invoice.is_deposit_to_sale)))])]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.xs) ? _c('el-table-column', {
    attrs: {
      "label": "销售模块",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "产品类别",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limC) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.typeCodeForm(scope.row.deliveryOrder.type_code)))]) : _c('span', [_vm._v(_vm._s(_vm.typeCodeForm(scope.row.deliveryOrder.type_code)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合同收款方式",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limC) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.contract.contract_payment_method))]) : _c('span', [_vm._v(_vm._s(scope.row.contract.contract_payment_method))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合同收款时间",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limC) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.timeFormate(scope.row.contract.contract_collection_date)))]) : _c('span', [_vm._v(_vm._s(_vm.timeFormate(scope.row.contract.contract_collection_date)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合同编号",
      "prop": "contract.contract_serial_number",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limC) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.contract.contract_serial_number))]) : _c('span', [_vm._v(_vm._s(scope.row.contract.contract_serial_number))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合同金额",
      "prop": "contract.contract_amount",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limC) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.contract.contract_amount))]) : _c('span', [_vm._v(_vm._s(scope.row.contract.contract_amount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合同状态",
      "prop": "contract.contract_status",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limC) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.contractState(scope.row.contract.contract_status)))]) : _c('span', [_vm._v(_vm._s(_vm.contractState(scope.row.contract.contract_status)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "经销商",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.jxs(scope.row.dealer_id)) + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品所在地",
      "width": "400"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limC) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.add))]) : _c('span', [_vm._v(_vm._s(scope.row.add))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户/设备负责人",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limC) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.purchaserInfo.manager))]) : _c('span', [_vm._v(_vm._s(scope.row.purchaserInfo.manager))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limC) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.purchaserInfo.manager_phone))]) : _c('span', [_vm._v(_vm._s(scope.row.purchaserInfo.manager_phone))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户特殊需求",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limC) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.purchaserInfo.customer_special_needs))]) : _c('span', [_vm._v(_vm._s(scope.row.purchaserInfo.customer_special_needs))])]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sc) ? _c('el-table-column', {
    attrs: {
      "label": "生产模块",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "穿戴配套",
      "prop": "deliveryOrder.wearable_device",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limA) ? _c('span', {
          staticClass: "changeColor"
        }, [(scope.row.deliveryOrder.wearable_device) ? _c('span', [_c('ul', {
          staticClass: "wareUl"
        }, [((scope.row.deliveryOrder.wearable_device >> 24) & 255) ? _c('li', [_vm._v("XL: " + _vm._s((scope.row.deliveryOrder.wearable_device >> 24) & 255))]) : _vm._e(), _vm._v(" "), ((scope.row.deliveryOrder.wearable_device >> 16) & 255) ? _c('li', [_vm._v("M: " + _vm._s((scope.row.deliveryOrder.wearable_device >> 16) & 255))]) : _vm._e(), _vm._v(" "), ((scope.row.deliveryOrder.wearable_device >> 8) & 255) ? _c('li', [_vm._v("S: " + _vm._s((scope.row.deliveryOrder.wearable_device >> 8) & 255))]) : _vm._e(), _vm._v(" "), (scope.row.deliveryOrder.wearable_device & 255) ? _c('li', [_vm._v("N: " + _vm._s(scope.row.deliveryOrder.wearable_device & 255))]) : _vm._e()])]) : _c('span', [_vm._v("无")])]) : _c('span', [(scope.row.deliveryOrder.wearable_device) ? _c('span', [_c('ul', {
          staticClass: "wareUl"
        }, [((scope.row.deliveryOrder.wearable_device >> 24) & 255) ? _c('li', [_vm._v("XL: " + _vm._s((scope.row.deliveryOrder.wearable_device >> 24) & 255))]) : _vm._e(), _vm._v(" "), ((scope.row.deliveryOrder.wearable_device >> 16) & 255) ? _c('li', [_vm._v("M: " + _vm._s((scope.row.deliveryOrder.wearable_device >> 16) & 255))]) : _vm._e(), _vm._v(" "), ((scope.row.deliveryOrder.wearable_device >> 8) & 255) ? _c('li', [_vm._v("S: " + _vm._s((scope.row.deliveryOrder.wearable_device >> 8) & 255))]) : _vm._e(), _vm._v(" "), (scope.row.deliveryOrder.wearable_device & 255) ? _c('li', [_vm._v("N: " + _vm._s(scope.row.deliveryOrder.wearable_device & 255))]) : _vm._e()])]) : _c('span', [_vm._v("无")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "气弹簧",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.springCode(scope.row.spring_code)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品版本号",
      "prop": "version_number",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limA) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.version_number))]) : _c('span', [_vm._v(_vm._s(scope.row.version_number))])]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.cp) ? _c('el-table-column', {
    attrs: {
      "label": "产品模块",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "销售时间",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limD) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.timeFormate(scope.row.afterSaleOrder.sales_date)))]) : _c('span', [_vm._v(_vm._s(_vm.timeFormate(scope.row.afterSaleOrder.sales_date)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "问题记录",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limD) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(_vm.problemRecord(scope.row.afterSaleOrder.problemCodes)))]) : _c('span', [_vm._v(_vm._s(_vm.problemRecord(scope.row.afterSaleOrder.problemCodes)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.limD) ? _c('span', {
          staticClass: "changeColor"
        }, [_vm._v(_vm._s(scope.row.afterSaleOrder.remark))]) : _c('span', [_vm._v(_vm._s(scope.row.afterSaleOrder.remark))])]
      }
    }])
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar downtool",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.DownExcel
    }
  }, [_vm._v("导出到Excel")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "span": 20,
      "layout": "total,sizes,prev, pager, next",
      "page-sizes": [20, 30, 40, 50],
      "page-size": _vm.Pagesize,
      "current-page": _vm.Curpage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "生产页面",
      "visible": _vm.SCvisible,
      "width": "520px",
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.SCvisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "穿戴佩戴情况：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('p', [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "50px"
    }
  }, [_vm._v("N: ")]), _c('el-input-number', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.form1.ChuanDaiN),
      callback: function($$v) {
        _vm.$set(_vm.form1, "ChuanDaiN", $$v)
      },
      expression: "form1.ChuanDaiN"
    }
  })], 1), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "50px"
    }
  }, [_vm._v("XL: ")]), _c('el-input-number', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.form1.ChuanDaiXL),
      callback: function($$v) {
        _vm.$set(_vm.form1, "ChuanDaiXL", $$v)
      },
      expression: "form1.ChuanDaiXL"
    }
  })], 1), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "50px"
    }
  }, [_vm._v("M: ")]), _c('el-input-number', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.form1.ChuanDaiM),
      callback: function($$v) {
        _vm.$set(_vm.form1, "ChuanDaiM", $$v)
      },
      expression: "form1.ChuanDaiM"
    }
  })], 1), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "50px"
    }
  }, [_vm._v("S: ")]), _c('el-input-number', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.form1.ChuanDaiS),
      callback: function($$v) {
        _vm.$set(_vm.form1, "ChuanDaiS", $$v)
      },
      expression: "form1.ChuanDaiS"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品版本号：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写修改内容",
      "auto-complete": "off",
      "maxlength": 50
    },
    model: {
      value: (_vm.form1.BanBen),
      callback: function($$v) {
        _vm.$set(_vm.form1, "BanBen", $$v)
      },
      expression: "form1.BanBen"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "padding": "10px 50px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.Subloading1
    },
    on: {
      "click": _vm.Sub1
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.SCTSVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.SCTSVisible = $event
      }
    }
  }, [_c('span', [_vm._v("是否确认修改并提交")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.SCTSVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Subdata1
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "财务修改",
      "visible": _vm.CWvisible,
      "append-to-body": "",
      "center": "",
      "width": "540px"
    },
    on: {
      "update:visible": function($event) {
        _vm.CWvisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开票日期：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "date",
      "placeholder": "可手动输入,如：20180101",
      "default-value": new Date(),
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.form2.KPdate),
      callback: function($$v) {
        _vm.$set(_vm.form2, "KPdate", $$v)
      },
      expression: "form2.KPdate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开票状态：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form2.KPstate),
      callback: function($$v) {
        _vm.$set(_vm.form2, "KPstate", $$v)
      },
      expression: "form2.KPstate"
    }
  }, [_vm._v("已开票")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.form2.KPstate),
      callback: function($$v) {
        _vm.$set(_vm.form2, "KPstate", $$v)
      },
      expression: "form2.KPstate"
    }
  }, [_vm._v("未开票")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发票编号：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写修改内容",
      "auto-complete": "off",
      "maxlength": 8
    },
    model: {
      value: (_vm.form2.KPnum),
      callback: function($$v) {
        _vm.$set(_vm.form2, "KPnum", $$v)
      },
      expression: "form2.KPnum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款日期1st：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "date",
      "placeholder": "可手动输入,如：20180101",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.form2.SKdate),
      callback: function($$v) {
        _vm.$set(_vm.form2, "SKdate", $$v)
      },
      expression: "form2.SKdate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款金额1st：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写修改内容",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.SKnum),
      callback: function($$v) {
        _vm.$set(_vm.form2, "SKnum", $$v)
      },
      expression: "form2.SKnum"
    }
  }), _vm._v(" 元\n\t\t\t\t")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款日期2nd：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "date",
      "placeholder": "可手动输入,如：20180101",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.form2.SKdate2),
      callback: function($$v) {
        _vm.$set(_vm.form2, "SKdate2", $$v)
      },
      expression: "form2.SKdate2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款金额2nd：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写修改内容",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.SKnum2),
      callback: function($$v) {
        _vm.$set(_vm.form2, "SKnum2", $$v)
      },
      expression: "form2.SKnum2"
    }
  }), _vm._v(" 元\n\t\t\t\t")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款日期3rd&after：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "date",
      "placeholder": "可手动输入,如：20180101",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.form2.SKdate3),
      callback: function($$v) {
        _vm.$set(_vm.form2, "SKdate3", $$v)
      },
      expression: "form2.SKdate3"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款金额3rd&after：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写修改内容",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.SKnum3),
      callback: function($$v) {
        _vm.$set(_vm.form2, "SKnum3", $$v)
      },
      expression: "form2.SKnum3"
    }
  }), _vm._v(" 元\n\t\t\t\t")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款状态：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form2.SKstate),
      callback: function($$v) {
        _vm.$set(_vm.form2, "SKstate", $$v)
      },
      expression: "form2.SKstate"
    }
  }, [_vm._v("押金")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.form2.SKstate),
      callback: function($$v) {
        _vm.$set(_vm.form2, "SKstate", $$v)
      },
      expression: "form2.SKstate"
    }
  }, [_vm._v("未收款")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.form2.SKstate),
      callback: function($$v) {
        _vm.$set(_vm.form2, "SKstate", $$v)
      },
      expression: "form2.SKstate"
    }
  }, [_vm._v("货款")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "押金转销售：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form2.ischange),
      callback: function($$v) {
        _vm.$set(_vm.form2, "ischange", $$v)
      },
      expression: "form2.ischange"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form2.ischange),
      callback: function($$v) {
        _vm.$set(_vm.form2, "ischange", $$v)
      },
      expression: "form2.ischange"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "padding": "10px 50px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.Subloading2
    },
    on: {
      "click": _vm.Sub2
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.CWTSVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.CWTSVisible = $event
      }
    }
  }, [_c('span', [_vm._v("是否确认修改并提交？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.CWTSVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Subdata2
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "销售修改",
      "visible": _vm.XSvisible,
      "append-to-body": "",
      "center": "",
      "width": "540px"
    },
    on: {
      "update:visible": function($event) {
        _vm.XSvisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form3
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同编号：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写修改内容",
      "auto-complete": "off",
      "maxlength": 30
    },
    model: {
      value: (_vm.form3.HTnum),
      callback: function($$v) {
        _vm.$set(_vm.form3, "HTnum", $$v)
      },
      expression: "form3.HTnum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同金额：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写修改内容",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form3.HTmoney),
      callback: function($$v) {
        _vm.$set(_vm.form3, "HTmoney", $$v)
      },
      expression: "form3.HTmoney"
    }
  }), _vm._v(" 元\n\t\t\t\t")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同收款方式：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写修改内容",
      "auto-complete": "off",
      "maxlength": 30
    },
    model: {
      value: (_vm.form3.Colmethod),
      callback: function($$v) {
        _vm.$set(_vm.form3, "Colmethod", $$v)
      },
      expression: "form3.Colmethod"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同收款日期",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "date",
      "placeholder": "可手动输入,如：20180101",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.form3.CoLdate),
      callback: function($$v) {
        _vm.$set(_vm.form3, "CoLdate", $$v)
      },
      expression: "form3.CoLdate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同状态：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form3.HTstate),
      callback: function($$v) {
        _vm.$set(_vm.form3, "HTstate", $$v)
      },
      expression: "form3.HTstate"
    }
  }, [_vm._v("已归档")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.form3.HTstate),
      callback: function($$v) {
        _vm.$set(_vm.form3, "HTstate", $$v)
      },
      expression: "form3.HTstate"
    }
  }, [_vm._v("未归档")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品所在地区：",
      "label-width": _vm.formLabelWidth2,
      "prop": "ssq"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "options": _vm.Addoptions
    },
    model: {
      value: (_vm.form3.ssq),
      callback: function($$v) {
        _vm.$set(_vm.form3, "ssq", $$v)
      },
      expression: "form3.ssq"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址：",
      "label-width": _vm.formLabelWidth2,
      "prop": "xxdz"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写详细地址",
      "maxlength": 50
    },
    model: {
      value: (_vm.form3.xxdz),
      callback: function($$v) {
        _vm.$set(_vm.form3, "xxdz", $$v)
      },
      expression: "form3.xxdz"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户/设备负责人：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写修改内容",
      "auto-complete": "off",
      "maxlength": 30
    },
    model: {
      value: (_vm.form3.Principal),
      callback: function($$v) {
        _vm.$set(_vm.form3, "Principal", $$v)
      },
      expression: "form3.Principal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系方式：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写修改内容",
      "auto-complete": "off",
      "maxlength": 15
    },
    model: {
      value: (_vm.form3.PrincipalPhone),
      callback: function($$v) {
        _vm.$set(_vm.form3, "PrincipalPhone", $$v)
      },
      expression: "form3.PrincipalPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户特殊需求：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写内容(最多250字)",
      "type": "textarea",
      "autosize": "",
      "auto-complete": "off",
      "maxlength": 250
    },
    model: {
      value: (_vm.form3.SpecialNeeds),
      callback: function($$v) {
        _vm.$set(_vm.form3, "SpecialNeeds", $$v)
      },
      expression: "form3.SpecialNeeds"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品类别：",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form3.type),
      callback: function($$v) {
        _vm.$set(_vm.form3, "type", $$v)
      },
      expression: "form3.type"
    }
  }, _vm._l((_vm.typeFilt), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "padding": "10px 50px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.Subloading3
    },
    on: {
      "click": _vm.Sub3
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.XSTSVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.XSTSVisible = $event
      }
    }
  }, [_c('span', [_vm._v("是否确认修改并提交")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.XSTSVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Subdata3
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "产品修改",
      "visible": _vm.CPvisible,
      "width": "1000px",
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.CPvisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "问题记录：",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._l((_vm.form4.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(tag)
        }
      }
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ 新问题")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写修改内容",
      "auto-complete": "off",
      "maxlength": 250
    },
    model: {
      value: (_vm.form4.Remark),
      callback: function($$v) {
        _vm.$set(_vm.form4, "Remark", $$v)
      },
      expression: "form4.Remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售日期",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "timestamp",
      "size": "small",
      "type": "date",
      "placeholder": "可手动输入,如：20180101"
    },
    model: {
      value: (_vm.form4.sales_date),
      callback: function($$v) {
        _vm.$set(_vm.form4, "sales_date", $$v)
      },
      expression: "form4.sales_date"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "padding": "10px 50px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.Subloading4
    },
    on: {
      "click": _vm.Sub4
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.CPTSVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.CPTSVisible = $event
      }
    }
  }, [_c('span', [_vm._v("是否确认修改并提交")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.CPTSVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Subdata4
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.leaderVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.leaderVisible = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("请选择需要修改的信息类别：")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.leaderChiose),
      callback: function($$v) {
        _vm.leaderChiose = $$v
      },
      expression: "leaderChiose"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("生产信息")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("财务信息")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("销售信息")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("产品信息")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.leaderVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.leaderOpen
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-225cf9ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AfterSalesTracking.vue
// module id = 1262
// module chunks = 1